module.exports = __webpack_public_path__ + "img/member-pic6.a946e36f.jpg";